"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var XBOX_FAMILY_NAME = 'Windows.Xbox';
var bridgeInstance;
var WinRtBridge = (function () {
    function WinRtBridge(context) {
        this.context = context;
    }
    WinRtBridge.getInstance = function (context) {
        if (!bridgeInstance) {
            bridgeInstance = new WinRtBridge(context);
        }
        return bridgeInstance;
    };
    WinRtBridge.prototype.getDeviceFamily = function () {
        return this.context.Windows.System.Profile.AnalyticsInfo.versionInfo.deviceFamily;
    };
    WinRtBridge.prototype.getDeviceId = function () {
        if (this.getDeviceFamily() === XBOX_FAMILY_NAME) {
            return this.getXboxDeviceId();
        }
        else {
            return this.getWindowsDeviceId();
        }
    };
    WinRtBridge.prototype.getXboxDeviceId = function () {
        var systemProfile = this.context.Windows.System.Profile;
        var systemIdentificationInfo = systemProfile.SystemIdentification.getSystemIdForPublisher();
        var idBuffer = systemIdentificationInfo.id;
        var dataReader = this.context.Windows.Storage.Streams.DataReader.fromBuffer(idBuffer);
        return dataReader.readGuid();
    };
    WinRtBridge.prototype.getWindowsDeviceId = function () {
        var easClientDeviceInformation = new this.context.Windows.Security.ExchangeActiveSyncProvisioning.EasClientDeviceInformation();
        return easClientDeviceInformation.id.toString();
    };
    WinRtBridge.prototype.instantiatePasswordVault = function () {
        return new this.context.Windows.Security.Credentials.PasswordVault();
    };
    WinRtBridge.prototype.createPasswordCredential = function (oAuthAppName, oAuthStorageKey, value) {
        return new this.context.Windows.Security.Credentials.PasswordCredential(oAuthAppName, oAuthStorageKey, value);
    };
    WinRtBridge.prototype.getDeviceFamilyVersion = function () {
        var deviceFamilyVersion = this.context.Windows.System.Profile.AnalyticsInfo.versionInfo.deviceFamilyVersion;
        var deviceFamilyVersionDecimalFormat = parseInt(deviceFamilyVersion, 0);
        if (isNaN(deviceFamilyVersionDecimalFormat)) {
            throw new Error('cannot parse device family version number');
        }
        var hexString = deviceFamilyVersionDecimalFormat.toString(16).toUpperCase();
        while (hexString.length !== 16) {
            hexString = '0' + hexString;
        }
        var hexStringIterator = 0;
        var versionString = '';
        while (hexStringIterator < hexString.length) {
            var subHexString = hexString.substring(hexStringIterator, hexStringIterator + 4);
            var decimalValue = parseInt(subHexString, 16);
            versionString += decimalValue + '.';
            hexStringIterator += 4;
        }
        return versionString.substring(0, versionString.length - 1);
    };
    WinRtBridge.prototype.addLifecycleEventListener = function (eventType, eventHandler) {
        this.context.Windows.UI.WebUI.WebUIApplication.addEventListener(eventType, eventHandler);
    };
    WinRtBridge.prototype.getActivationProtocol = function () {
        return this.context.Windows.ApplicationModel.Activation.ActivationKind.protocol;
    };
    WinRtBridge.prototype.getMediaRemoteControls = function () {
        return this.context.Windows.Media.SystemMediaTransportControls.getForCurrentView();
    };
    WinRtBridge.prototype.getMediaPlaybackStatus = function () {
        return this.context.Windows.Media.MediaPlaybackStatus;
    };
    WinRtBridge.prototype.getMediaRemoteButtons = function () {
        return this.context.Windows.Media.SystemMediaTransportControlsButton;
    };
    return WinRtBridge;
}());
exports.WinRtBridge = WinRtBridge;
